// Widget de suporte da Soluciona (Solux).
// Injeta o <script> oficial UMA vez, apenas para usuarios autenticados,
// usando nome/email vindos da sessao (localStorage 'userPioneira', setado no
// login a partir da resposta da API) — nunca valores fixos nem de input.
// Os data-* sao setados via setAttribute (DOM escapa automaticamente: sem XSS).

const WIDGET_ID = 'solux-suporte-widget';
const WIDGET_SRC = 'https://solux.soluciona.inf.br/suporte.js';
const WIDGET_KEY = 'w_0sIBGmHAvguhBrXS1NEzRs87';

export function carregarSuporteSolux() {
  try {
    if (typeof document === 'undefined') return;
    // Nao duplica: carrega uma unica vez por pagina.
    if (document.getElementById(WIDGET_ID)) return;

    // Somente para usuario autenticado (identidade confiavel).
    const user = JSON.parse(localStorage.getItem('userPioneira') || 'null');
    if (!user || !user.token) return;

    const s = document.createElement('script');
    s.id = WIDGET_ID;
    s.src = WIDGET_SRC;
    s.async = true;
    s.setAttribute('data-key', WIDGET_KEY);
    s.setAttribute('data-nome', user.name || '');
    s.setAttribute('data-email', user.email || '');
    document.body.appendChild(s);
  } catch (e) {
    // Suporte e opcional: nunca deve quebrar a aplicacao.
    console.error('Falha ao carregar o widget de suporte Solux:', e);
  }
}
